import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config/config';

const useAnalytics = () => {
  const location = useLocation();
  const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

  const trackPageView = useCallback(async (page: string) => {
    if (isDevelopment) {
      console.log('Analytics disabled in development mode');
      return;
    }

    try {
      await fetch(`${config.api.baseUrl}/analytics/pageview`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ page })
      });
    } catch (error) {
      console.error('Failed to track page view:', error);
    }
  }, [isDevelopment]);

  const trackInteraction = async (action: string, details: any = null) => {
    if (isDevelopment) {
      console.log('Analytics disabled in development mode');
      return;
    }

    try {
      await fetch(`${config.api.baseUrl}/analytics/interaction`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page: location.pathname,
          action,
          details
        })
      });
    } catch (error) {
      console.error('Failed to track interaction:', error);
    }
  };

  // Spåra sidvisningar automatiskt
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname, trackPageView]);

  return {
    trackInteraction
  };
};

export default useAnalytics; 